import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { BookElementDetail } from "@app/types";
import BookService from "@app/services/http/book.service";
import clsx from "clsx";

interface UnlockBookElementModalProps {
  bookElement: BookElementDetail;
  isEnoughPoint: boolean;
}

function UnlockBookElementModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<UnlockBookElementModalProps>) {
  const handleUnlockClick = async () => {
    if (portalData?.bookElement) {
      BookService.unlockElement(portalData.bookElement.id).then(() => {
        portalDialogRef.close({ status: "success" });
      });
    }
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[380px] pb-6 px-6">
        <div className="pt-6 text-[#171A20] font-[SVN-Gilroy] text-2xl font-bold text-center">
          Mở khóa
        </div>
        <div className="pb-3 text-[#424E62] font-[SVN-Gilroy] text-[16px] font-medium text-center">
          Đổi kas để mở khóa chương.
        </div>
        <Button
          containerClassName="mt-2"
          label={`${portalData?.bookElement.point} kas`}
          labelClassName="font-[SVN-Gilroy] tracking-[0.024px]"
          width=""
          className={clsx(
            "font-bold px-11 !rounded-[22px] !h-[48px] !leading-[48px]",
            portalData?.isEnoughPoint
              ? "bg-gradient-to-b from-[#5A82D7] to-[#4667CA]"
              : "!bg-[#7AA2E0] cursor-default pointer-events-none"
          )}
          onClick={handleUnlockClick}
        />
      </div>
    </Modal>
  );
}

export default UnlockBookElementModal;
